import { createContext } from "react";

export const AnimationContext = createContext()
export const CameraContext = createContext()

